export default __webpack_public_path__ + "static/media/monitoreo.f45777cd.png";